import { getWebAuth } from "@lib/auth0";
import { saveCurrentPathForRedirect } from "@lib/redirectAfterLogin";

export function signInAgain() {
    saveCurrentPathForRedirect();
    getWebAuth().authorize({ prompt: "login", responseType: "token" });
}
